<template>
	<div id="vacancies-main-container">
		<div class="vacanciesIntro">
			<div class="container content-header position-relative">
				<h1 class="biggest text-center">Oeps...</h1>
			</div>
            <div class="vacancies-white-block"></div>
		</div>
        <div class="container" style="margin-top: -150px;background-color:white;padding-top:100px;margin-bottom:100px;">
            <div class="text-center">
              <p>Het lijkt erop dat deze pagina niet bestaat.</p>
              <p><router-link to="/">Ga terug naar home</router-link></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Error404Page',
}
</script>
